import { Component } from 'react';
import { createPortal } from 'react-dom';

const portalRoot = document.getElementById('portal');

class Portal extends Component {
    private el = document.createElement('div');

    componentDidMount = () => {
        portalRoot && portalRoot.appendChild(this.el);
    };

    componentWillUnmount = () => {
        portalRoot && portalRoot.removeChild(this.el);
    };

    render() {
        const { children } = this.props;
        return createPortal(children, this.el);
    }
}

export default Portal;
